module.exports = __webpack_public_path__ + "img/seatMap.5339ec9d.png";